import { css, cx } from "@emotion/css";
import { Divider } from "@mui/material";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import Gallery from "src/components/NewComponents/Images/Gallery";
import { useSlot } from "src/components/Slots/SlotsContext";

import { htmlFormatter } from "src/formatters/htmlFormatter";
import { hasLimitedAccess } from "src/helpers/getPermissions";
import isMobile from "src/helpers/isMobile";
import { getAppConfig } from "src/hooks/useAppConfig";
import { useGetDiscussion } from "src/hooks/useDiscussion";
import { useFontSize } from "src/hooks/useFontSize";
import { useNoCopy } from "src/hooks/useNoCopy";

export const OwnDiscussion = ({ questionId, onEditRag }) => {
	const { t } = useTranslation();
	const { fontSizeClass } = useFontSize();
	const appConfig = getAppConfig();
	const { onCopy, noCopyClassName } = useNoCopy({
		config: appConfig.copyContentSettings.discussion,
	});
	const { isLoading, data } = useGetDiscussion(questionId, !hasLimitedAccess());
	const EditSlot = useSlot("ownDiscussion");
	if (isLoading) return null;

	const { discussion, source, images, type } = data;
	const view = (
		<div className="question-discussion">
			<div
				onCopy={(e) =>
					onCopy(e, {
						questionId,
						type: "Discussion",
					})
				}
				className={cx("fr-view", noCopyClassName, fontSizeClass)}
			>
				{htmlFormatter(discussion)}
			</div>
			{!!source && (
				<div
					onCopy={(e) =>
						onCopy(e, {
							questionId,
							type: "Discussion",
						})
					}
					className={cx(
						"fr-view border-top-1 flex flex-col gap-8",
						noCopyClassName,
						fontSizeClass,
					)}
				>
					<h5
						className={cx(
							"mt-8 mb-0",
							fontSizeClass,
							css`
                font-weight: 600;
              `,
						)}
					>
						{t("exam.source")}
					</h5>
					<div
						className={cx(css`
              ol {
                margin: 0;
              }
            `)}
					>
						{htmlFormatter(source)}
					</div>
				</div>
			)}
			{images && images.length > 0 && (
				<div>
					<Divider />
					<Typography variant="body2" component="span">
						{t("exam.images.discussion.title")}
					</Typography>
					<Gallery images={images} maxImages={isMobile() ? 3 : 7} />
				</div>
			)}
		</div>
	);

	if (!EditSlot) return view;

	return (
		<EditSlot
			key={questionId}
			questionId={questionId}
			discussion={discussion}
			source={source}
			type={type}
			onEditRag={onEditRag}
		>
			{view}
		</EditSlot>
	);
};
